export function getAuthHeader() {
  return 'Bearer ' + localStorage.getItem('access_token');
}
